import { createContext, useContext } from 'react';

export const JourneyNameContext = createContext<string | null>(null);

/** Active journey name, or null outside a `<JourneyScope>` (steps run untraced). */
export function useOptionalJourneyName(): string | null {
    return useContext(JourneyNameContext);
}

/**
 * Active journey name; throws outside a `<JourneyScope>`.
 * Prefer {@link useOptionalJourneyName} when the shell may omit a scope.
 */
export function useJourneyName(): string {
    const name = useContext(JourneyNameContext);
    if (!name) {
        throw new Error('useJourneyName must be used within a <JourneyScope>');
    }
    return name;
}
